module.exports = __webpack_public_path__ + "static/img/wechatRule.6350aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechatRule.png
// module id = 485
// module chunks = 84